import { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { AuthImage } from "@/components/AuthImage";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export function PhotoUpload({ value, onChange, label = "Photo" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  async function pick(e) {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Please choose an image"); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error("Image must be under 5MB"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload/student-photo", fd);
      onChange(data.url);
      toast.success("Photo uploaded");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  }

  return (
    <div>
      <Label>{label}</Label>
      <div className="flex items-center gap-3 mt-1.5">
        {value
          ? <AuthImage testid="student-photo-preview" src={value} alt="Student" className="h-10 w-10 rounded-lg object-cover" />
          : <div className="h-10 w-10 rounded-lg bg-violet-50 border border-dashed border-violet-200 flex items-center justify-center text-violet-400"><Camera size={16} /></div>}
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={pick} data-testid="student-photo-input" />
        <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} data-testid="student-photo-upload-btn" className="border-violet-200 text-violet-700">
          {busy ? <Loader2 size={14} className="animate-spin mr-1" /> : <Camera size={14} className="mr-1" />} {value ? "Change" : "Upload"}
        </Button>
        {value && (
          <button type="button" data-testid="student-photo-remove" onClick={() => onChange("")} className="text-slate-400 hover:text-red-600"><X size={16} /></button>
        )}
      </div>
    </div>
  );
}
